import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { routeForRole } from "./Login";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const process = async () => {
      try {
        const hash = location.hash || window.location.hash;
        const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
        if (!sessionId) throw new Error("no session_id");
        const lang = localStorage.getItem("gls_lang") || "fr";
        const { data: user } = await api.post("/auth/google/session", { session_id: sessionId, lang });

        let finalUser = user;
        if (!user.role) {
          const pendingRole = localStorage.getItem("gls_pending_role");
          if (pendingRole && ["company", "candidate"].includes(pendingRole)) {
            const lang = localStorage.getItem("gls_lang") || "fr";
            const { data } = await api.post("/auth/set-role", { role: pendingRole, lang });
            finalUser = data;
          }
        }
        localStorage.removeItem("gls_pending_role");
        setUser(finalUser);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(routeForRole(finalUser.role), { replace: true, state: { user: finalUser } });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    process();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50" data-testid="auth-callback-loading">
      <Loader2 className="h-8 w-8 animate-spin text-sky-500" />
    </div>
  );
}
